import { useEffect, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Nav, Tab } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import { Link, Outlet, useLocation } from 'react-router-dom';

export const ReportsAdmin = () => {
  const [tab, setTab] = useState("status");
  const { pathname } = useLocation();
  const [isActive, setIsActive] = useState(false);
  const refs = {
    "status": useRef(null),
    "lists": useRef(null),
    "companies": useRef(null),
    "ongoing": useRef(null),
    "periods": useRef(null)
  } as {[x: string]: any};

  useEffect(() => {
    let tab = pathname === '/reportsAdmin' ? 'status' : pathname?.split('/').pop();
    if (tab) {
      setTab(tab);
      // Focus to correct tab
      let ref = refs[tab];
      ref.current.focus();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const handleSelectedTab = (eventKey : any) => {
    setTab(eventKey);
  }

  const handleResponsiveTabs = (eventKey : any) => {
    setIsActive(current => !current);
  }

  return (
    <div>
      <h1><FormattedMessage id="reports.reports"/></h1>
      <p className="info"><i className="fa fa-info-circle me-2"></i>
        <FormattedMessage id="reports.reportstatus"/>
      </p>
      
      <div className="responsive-tabs-wrp">
        <div className="responsive-nav tab-buttons">
          <Button className="tab-button toggle-btn" onClick={handleResponsiveTabs}>
            <span className="active"><FormattedMessage id={"reports." + tab}/></span>
          </Button>
        </div>

        <Tab.Container activeKey={tab} defaultActiveKey={tab} id="tab" onSelect={handleSelectedTab}>
          <Nav className={'nav-tabs responsive-tabs' + (isActive ? ' show' : '')}>
            <Nav.Item>
              <Nav.Link ref={refs.status} eventKey="status" as={Link} to="/reportsAdmin/status">
                <i aria-hidden="true" className="fa fa-check mr-2"></i>
                <span> <FormattedMessage id="reports.status"/></span>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link ref={refs.lists} eventKey="lists" as={Link} to="/reportsAdmin/lists">
                <i aria-hidden="true" className="fa fa-list mr-2"></i><span> <FormattedMessage id="reports.lists"/></span>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link ref={refs.companies} eventKey="companies" as={Link} to={`/reportsAdmin/companies`}>
                <i aria-hidden="true" className="fa fa-building mr-2"></i><span> <FormattedMessage id="reports.companies"/></span>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link ref={refs.ongoing} eventKey="ongoing" as={Link} to={`/reportsAdmin/ongoing`}>
                <i aria-hidden="true" className="fa fa-hourglass mr-2"></i><span> <FormattedMessage id="reports.ongoing"/></span>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link ref={refs.periods} eventKey="periods" as={Link} to={`/reportsAdmin/periods`}>
                <i aria-hidden="true" className="fa fa-calendar mr-2"></i><span> <FormattedMessage id="reports.periods"/></span>
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </Tab.Container>

        <Tab.Content>
          <Outlet/>
        </Tab.Content>
      </div>
    </div>
  );
};

